import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import get from 'lodash/get'
import { skin } from 'Utils'
import skins from './skins'
import View from './component'
import { ProductModal } from 'Blocks'
import config from 'Config'

class ProductCard extends Component {
  static propTypes = {
    pageName: PropTypes.string,
    product: PropTypes.shape({
      flags: PropTypes.shape({
        isStocked: PropTypes.bool
      }),
      uuid: PropTypes.any
    }),
    screenType: PropTypes.string,
    useCompareModal: PropTypes.bool
  }

  state = {
    modalOpen: false
  }

  handleOpen = () => {
    this.setState({ modalOpen: true })
  }

  handleClose = () => {
    this.setState({ modalOpen: false })
  }

  render() {
    const {
      product,
      useCompareModal = false,
      screenType = '',
      pageName = ''
    } = this.props

    const cardConfig = config.productCards
    const resolveCard = size =>
      cardConfig[pageName]
        ? cardConfig[pageName][size]
        : cardConfig.default[size]
    const ourAffiliateLink = size => resolveCard(size) === 'AffiliateLink'
    const s = screenType === 'small' ? 'small' : 'large'

    return (
      <Fragment>
        <View
          handleOpen={this.handleOpen}
          {...this.props}
          ourAffiliateLink={ourAffiliateLink(s)}
        />

        {useCompareModal && !product.flags.isStocked && (
          <ProductModal
            on={this.state.modalOpen}
            close={this.handleClose}
            productUuid={product.uuid}
          />
        )}
      </Fragment>
    )
  }
}

const mapStateToProps = state => ({
  screenType: get(state, 'UI.screenType', '')
})

export default skin(connect(mapStateToProps, null)(ProductCard), skins)
